import styled from "styled-components";
import { Anchor } from "@ebscois/react-component-library";

export const StyledAnchor = styled(Anchor)`
  ${({ theme }) => `
    padding: 0.5rem 1rem;
    display: flex;
    white-space: nowrap;
    text-decoration: none;
    color: ${theme.colors.gray800} !important; //This is set to high specificity in RCL
    font-size: ${theme.font.size.sm};
    &:hover,
    &:focus {
      text-decoration: none !important;
      font-weight: ${theme.font.weight.semibold};
    }
  `}
`;
